import React from 'react';

function HomeAbout() {
  return (
    <section className="home-about">
      <p className="home-about__lead">
        <strong>North Star Promotions is an independent PR, music influencer, and label support agency</strong> operating out of London (UK) and Vienna (Austria). We focus on a wide range of contemporary music — from pop and indie to electronic and hip-hop — working with sounds and creators we truly stand behind.
      </p>
      <p className="home-about__section">
        <span className="home-about__gradient-text">
          We offer international press outreach, print and online magazine features, and curated influencer marketing. <br/><br/>
        </span>
        {' '}With a sincere love for music discovery, we ensure that every project reaches the right audience with intention and care.<br />
        We're realistic — no overpromising, just dedicated effort and results that matter. Every artist has a unique vision, and we pride ourselves on tailoring our support to help them move toward it, step by step.
      </p>
      <p className="home-about__section">
        Whether you're an artist ready to amplify your next release or an industry professional interested in collaborating, we'd love to connect. If you're a journalist, editor, or influencer and would like to be on our promo list, just drop us a line using the contact info below.
      </p>
    </section>
  );
}

export default HomeAbout;
